<template>
    <div class="empty-extraction-state">
        <div class="has-text-centered">
            <span class="icon is-large has-text-warning mb-4">
                <i class="fas fa-exclamation-triangle fa-3x"></i>
            </span>
            <h4 class="title is-5 mb-3">
                {{ translate("page.category_manager.extraction_empty_title") }}
            </h4>
            <p class="mb-4">
                {{ translate("page.category_manager.extraction_empty_description") }}
            </p>
            <div class="content has-text-left empty-extraction-hints">
                <p class="has-text-weight-semibold mb-2">
                    {{ translate("page.category_manager.extraction_empty_hints_title") }}
                </p>
                <ul>
                    <li>{{ translate("page.category_manager.extraction_empty_hint_1") }}</li>
                    <li>{{ translate("page.category_manager.extraction_empty_hint_2") }}</li>
                    <li>{{ translate("page.category_manager.extraction_empty_hint_3") }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
</script>

<style scoped>
    .empty-extraction-state {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        padding: 2rem;
    }

    .empty-extraction-hints {
        max-width: 400px;
        margin: 0 auto;
        background: var(--bulma-background);
        padding: 1rem 1.5rem;
        border-radius: 6px;
    }

    .empty-extraction-hints ul {
        margin-top: 0.5rem;
        margin-bottom: 0;
    }
</style>
